import { useUserToken } from "./useUserToken";

export const useIsAuthenticated = (): boolean => {
	const token = useUserToken();
	return Boolean(token?.authenticated);
};
